import {
	post
} from '@/util/request'

export default {
	//新的登录
	//发送验证码
	send: query => post(`/system/send`, query),
	//登录
	signin: query => post(`/system/signin`, query),
	//旧的登录
	login: query => post(`/system/auth`, query),
	getUserInfo: query => post(`/system/info`, query),
	openAuth: query => post(`/system/openAuth`, query),
	/**
	 * 首次登录 - 获取短信验证码
	 * @param query
	 * @returns {*}
	 */
	sendVerifyCode: query => post(`/system/sendVerifyCode`, query),
	/**
	 * 首次登录 - 身份验证提交
	 * @param query
	 * @returns {*}
	 */
	submitIdentityVerify: query => post(`/system/submitIdentityVerify`, query),
	logout: query => post(`/system/logout`, query),

	/**
	 * 找回密码 - 步骤1 - 根据用户名获取打码手机号
	 * @param query
	 * @returns {*}
	 */
	getMobileByLoginName: query => post(`/system/getMobileByLoginName`, query),

	/**
	 * 找回密码 - 步骤2 - 发送找回密码短信
	 * @param query
	 * @returns {*}
	 */
	sendResetPassMsg: query => post(`/system/sendResetPassMsg`, query),

	/**
	 * 找回密码 - 步骤3 - 校验短信验证码
	 * @param query
	 * @returns {*}
	 */
	checkResetPassVerify: query => post(`/system/checkResetPassVerify`, query),
	/**
	 * 找回密码 - 步骤4 - 重设密码
	 * @param query
	 * @returns {*}
	 */
	restPassForBack: query => post(`/system/restPassForBack`, query),
	/**
	 * 修改密码接口
	 * @param query
	 * @returns {*}
	 */
	editPassword: query => post(`/system/editPassword`, query),
	/**
	 * 取系统公告
	 * @param query
	 * @returns {*}
	 */
	getSysMsg: query => post(`/system/getSysMsg`, query),

	post: query => post(query.url, query.data),
	
	/**
	 * 第三方登录
	 * @param query
	 * @returns {*}
	 */
	threepartylogin: query => post(`/usercenter/threepartylogin`, query),
	
	
}
